/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { ConversationalAgentInferencerPolymorphicConversationalAgentInferencerCelina } from './ConversationalAgentInferencerPolymorphicConversationalAgentInferencerCelina';
import {
  ConversationalAgentInferencerPolymorphicConversationalAgentInferencerCelinaFromJSON,
  ConversationalAgentInferencerPolymorphicConversationalAgentInferencerCelinaFromJSONTyped,
  ConversationalAgentInferencerPolymorphicConversationalAgentInferencerCelinaToJSON,
} from './ConversationalAgentInferencerPolymorphicConversationalAgentInferencerCelina';
import type { ConversationalAgentInferencerPolymorphicConversationalAgentInferencerOpenAIAssistant } from './ConversationalAgentInferencerPolymorphicConversationalAgentInferencerOpenAIAssistant';
import {
  ConversationalAgentInferencerPolymorphicConversationalAgentInferencerOpenAIAssistantFromJSON,
  ConversationalAgentInferencerPolymorphicConversationalAgentInferencerOpenAIAssistantFromJSONTyped,
  ConversationalAgentInferencerPolymorphicConversationalAgentInferencerOpenAIAssistantToJSON,
} from './ConversationalAgentInferencerPolymorphicConversationalAgentInferencerOpenAIAssistant';

/**
 * @type ConversationalAgentInferencerPolymorphic
 *
 * @export
 */
export type ConversationalAgentInferencerPolymorphic =
  | ({ protocol: 'CELINA' } & ConversationalAgentInferencerPolymorphicConversationalAgentInferencerCelina)
  | ({
      protocol: 'OPEN_AI_ASSISTANT';
    } & ConversationalAgentInferencerPolymorphicConversationalAgentInferencerOpenAIAssistant);

export function ConversationalAgentInferencerPolymorphicFromJSON(json: any): ConversationalAgentInferencerPolymorphic {
  return ConversationalAgentInferencerPolymorphicFromJSONTyped(json, false);
}

export function ConversationalAgentInferencerPolymorphicFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ConversationalAgentInferencerPolymorphic {
  if (json == null) {
    return json;
  }
  switch (json['protocol']) {
    case 'CELINA':
      return Object.assign(
        {},
        ConversationalAgentInferencerPolymorphicConversationalAgentInferencerCelinaFromJSONTyped(json, true),
        { protocol: 'CELINA' } as const,
      );
    case 'OPEN_AI_ASSISTANT':
      return Object.assign(
        {},
        ConversationalAgentInferencerPolymorphicConversationalAgentInferencerOpenAIAssistantFromJSONTyped(json, true),
        { protocol: 'OPEN_AI_ASSISTANT' } as const,
      );
    default:
      throw new Error(
        `No variant of ConversationalAgentInferencerPolymorphic exists with 'protocol=${json['protocol']}'`,
      );
  }
}

export function ConversationalAgentInferencerPolymorphicToJSON(
  value?: ConversationalAgentInferencerPolymorphic | null,
): any {
  if (value == null) {
    return value;
  }
  switch (value['protocol']) {
    case 'CELINA':
      return ConversationalAgentInferencerPolymorphicConversationalAgentInferencerCelinaToJSON(value);
    case 'OPEN_AI_ASSISTANT':
      return ConversationalAgentInferencerPolymorphicConversationalAgentInferencerOpenAIAssistantToJSON(value);
    default:
      throw new Error(
        `No variant of ConversationalAgentInferencerPolymorphic exists with 'protocol=${value['protocol']}'`,
      );
  }
}
